import React, { useCallback, useEffect, useRef, useState } from 'react';
import authenticationService from 'services/AuthenticationService';
import './Login-sso.scss';
import { loginConfigurationRepository } from './AuthenticationRepository';
import { Logo } from 'models/Logo';
import { useHistory } from 'react-router';
import { LOGIN_AUTHENCATION_ROUTE } from 'config/route-consts';

function LoginSSO() {
  const ref = useRef<boolean>(true);

  const [logo, setLogo] = useState<Logo>(new Logo());

  useEffect(() => {
    if (ref) {
      authenticationService.get().then(item => {
        setLogo(item);
        ref.current = false;
      });
      loginConfigurationRepository.getLoginProfile().then(res => {
        res?.forEach(element => {
          if (element?.code === 'MICROSOFT') {
            localStorage.setItem('loginConfigurationId', element?.id);
          }
        });
      });
    }
  }, [setLogo]);
  const handleLoginWithSSO = useCallback(() => {
    loginConfigurationRepository
      .getAuthorizationEndpoint(localStorage.getItem('loginConfigurationId'))
      .then(res => {
        return window.open(res.toString(), '_self');
      });
  }, []);

  const history = useHistory();

  const gotoAuthenLogin = useCallback(() => {
    history.push(LOGIN_AUTHENCATION_ROUTE);
  }, [history]);

  return (
    <>
      <div className="login-sso__wrapper d-flex">
        <div className="login-sso__left-side">
          <div className="login-sso__info"></div>
        </div>
        <div className="login-sso__right-side d-flex flex-column">
          <div className="login-sso-left__header">
            <img
              className="header__logo"
              src={logo.icon}
              alt="IMG"
              height={150}
              width={150}
              onClick={gotoAuthenLogin}
            />
          </div>
          <div className="login-sso-left__body">
            <div className="login-sso__form d-flex flex-column">
              <div>
                <div className="form__action-button">
                  <div className="form__button" onClick={handleLoginWithSSO}>
                    <span>Đăng nhập SSO/Login with SSO</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LoginSSO;
